import { RELATED_SEARCHES_EXPERIENCE } from 'constants/TestTarget';

const MAX_RELATED_SEARCH_TERMS = 8; // BR-003 / AC-006/007 (shell-owned cap)
const MIN_RELATED_SEARCH_TERMS = 3; // BR-002 / AC-008
const MIN_PRODUCT_ROWS = 2; // BR-004 / AC-009/021
const PLACEHOLDER_IMAGE_SRC = '/img/ufe/image-error-white.svg'; // P0-003 / AC-012/013 (matches ProductImage fallback)
const RELATED_SEARCH_TYPE_VALUE = 'related search'; // SBR-3535 AC1 — prevSearchType data-layer value; Adobe Launch maps it to eVar42

// Single visibility source: the SAME predicate gates the grid reservation AND the shell render.
// Eligible iff challengerOne OR challengerTwo OR challengerThree variant AND >=3 terms AND >=2 product rows.
const isRelatedSearchesEligible = (variant, terms, productRowsCount) =>
    (variant === RELATED_SEARCHES_EXPERIENCE.CHALLENGER_ONE ||
        variant === RELATED_SEARCHES_EXPERIENCE.CHALLENGER_TWO ||
        variant === RELATED_SEARCHES_EXPERIENCE.CHALLENGER_THREE) &&
    (terms?.length || 0) >= MIN_RELATED_SEARCH_TERMS &&
    productRowsCount >= MIN_PRODUCT_ROWS;

export {
    MAX_RELATED_SEARCH_TERMS,
    MIN_RELATED_SEARCH_TERMS,
    MIN_PRODUCT_ROWS,
    PLACEHOLDER_IMAGE_SRC,
    RELATED_SEARCH_TYPE_VALUE,
    isRelatedSearchesEligible
};
